import Vue from "vue";

export default {
  postDispositivo(dispositivo) {
    return Vue.prototype.$http.post("/acessos/dispositivos", dispositivo);
  },

  getDispositivos(page = 0, filtro) {
    let requisicao = `/acessos/dispositivos?page=${page}`;

    if (filtro) {
      requisicao += `&${new URLSearchParams(filtro).toString()}`;
    }

    return Vue.prototype.$http.get(requisicao);
  },

  getDispositivo(acessoDispositivoId) {
    return Vue.prototype.$http.get(
      `/acessos/dispositivos/${acessoDispositivoId}`
    );
  },
  autorizarDispositivo(id) {
    return Vue.prototype.$http.post(`/acessos/dispositivos/${id}/autorizar`);
  },
  negarDispositivo(id) {
    return Vue.prototype.$http.post(`/acessos/dispositivos/${id}/recusar`);
  },
  bloquearDispositivo(id) {
    return Vue.prototype.$http.post(`/acessos/dispositivos/${id}/bloquear`);
  },
  getTokenDispositivo(id) {
    return Vue.prototype.$http.get(`/acessos/dispositivos/${id}/token`);
  },
  validarQrCode(token) {
    return Vue.prototype.$http.get(`/acessos/dispositivos/validar-qr/${token}`);
  },

  registrarEntrada(idAcessoDispositivo) {
    return Vue.prototype.$http.post(
      `/acessos/dispositivos/${idAcessoDispositivo}/registrar-entrada`
    );
  },
};
